import type { JSX, PropsWithChildren } from 'react';

import type { MovementInfo } from 'src/app/pages/movement/shared/api';
import { MovementContext } from 'src/app/pages/movement/shared/context';

type Props = {
	movementData: MovementInfo;
};

export function MovementContextProvider({ movementData, children }: PropsWithChildren<Props>): JSX.Element {
	return <MovementContext.Provider value={movementData}>{children}</MovementContext.Provider>;
}
